// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import NotFound from "../../Error/NotFound";
import Ticker from "../../GraphicElements/Ticker";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
    isLoaderFinished: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    isLoaderFinished
}) => {

    const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    // Il video carica sempre al mount, ma quando cambia la props del loader lo fa ripartire da capo
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleVideoStart = () => {
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error("Errore durante la riproduzione del video:", error);
            });
        }
    }

    useEffect(() => {
        handleVideoStart();
    }, [])

    useEffect(() => {
        if (isLoaderFinished) {
            videoRef.current?.pause();
            if (videoRef.current) {
                videoRef.current.currentTime = 0;
            }
            handleVideoStart();
        }
    }, [isLoaderFinished]);

    // console.log(isLoaderFinished, "isLoaderFinished in SubHeaderHome.tsx");

    // -----------------------------------------------------------------------------------------------------

    // Transizione per rendere visibile il text wrapper
    const [boxVisible, setBoxVisible] = useState(false);

    useEffect(() => {
        const handleVisible = () => {
            setBoxVisible(true)
        };

        if (isLoaderFinished) {
            const timer = setTimeout(handleVisible, 1000);
            return () => clearTimeout(timer);
        }
    }, [isLoaderFinished]);

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner bg-overlay-white-10">
            {false && (
                <video ref={videoRef} muted loop playsInline onLoadedData={handleVideoStart}>
                    <source src={`${LARGE_FILES_URL}/videoHero.mp4`} type="video/mp4" />
                </video>
            )}


            <img src="/assets/images/inHome/hero.webp" alt={t('homePage.hero.altImage') as string} />

            <div className={`text-wrapper ${boxVisible ? 'visible' : ''}`}>
                <p className="sub-title mb-0" dangerouslySetInnerHTML={{ __html: t('homePage.hero.subTitle') as string }}></p>
                <h1 className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }}></h1>
                <p dangerouslySetInnerHTML={{ __html: t('homePage.hero.para') as string }}></p>
                <Link to="/properties" className="btn btn-primary">
                    {t('homePage.hero.button')}
                </Link>
            </div>
            <Ticker />
            
        </section>
    );
};

export default SubHeaderHome;